import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-actions-box',
  templateUrl: './actions-box.component.html',
  styleUrls: ['./actions-box.component.scss']
})
export class ActionsBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
